export const DRIVERS_ACTION_TYPES = {
	
	GET_PAGINATE_DRIVER_LIST_REQUEST: 'GET_PAGINATE_DRIVER_LIST_REQUEST',
	GET_PAGINATE_DRIVER_LIST_SUCCESS: 'GET_PAGINATE_DRIVER_LIST_SUCCESS',
	GET_PAGINATE_DRIVER_LIST_SUCCESS_ADD_MORE: 'GET_PAGINATE_DRIVER_LIST_SUCCESS_ADD_MORE',
	GET_PAGINATE_DRIVER_LIST_FAILURE: 'GET_PAGINATE_DRIVER_LIST_FAILURE',
	GET_PAGINATE_DRIVER_LIST_EMPTY: 'GET_PAGINATE_DRIVER_LIST_EMPTY',


	COUNT_PAGINATE_DRIVER_LIST_REQUEST: 'COUNT_PAGINATE_DRIVER_LIST_REQUEST',
	COUNT_PAGINATE_DRIVER_LIST_SUCCESS: 'COUNT_PAGINATE_DRIVER_LIST_SUCCESS',
	COUNT_PAGINATE_DRIVER_LIST_FAILURE: 'COUNT_PAGINATE_DRIVER_LIST_FAILURE',
	COUNT_PAGINATE_DRIVER_LIST_EMPTY: 'COUNT_PAGINATE_DRIVER_LIST_EMPTY',

	UPDATE_ONE_DRIVER_INFO_REQUEST: 'UPDATE_ONE_DRIVER_INFO_REQUEST',
	UPDATE_ONE_DRIVER_INFO_SUCCESS: 'UPDATE_ONE_DRIVER_INFO_SUCCESS',
	UPDATE_ONE_DRIVER_INFO_FAILURE: 'UPDATE_ONE_DRIVER_INFO_FAILURE',

	//## Driver License Document
	GET_ONE_DRIVER_LICENSE_DOC_LIST_REQUEST: 'GET_ONE_DRIVER_LICENSE_DOC_LIST_REQUEST',
	GET_ONE_DRIVER_LICENSE_DOC_LIST_SUCCESS: 'GET_ONE_DRIVER_LICENSE_DOC_LIST_SUCCESS',
	GET_ONE_DRIVER_LICENSE_DOC_LIST_FAILURE: 'GET_ONE_DRIVER_LICENSE_DOC_LIST_FAILURE',
	GET_ONE_DRIVER_LICENSE_DOC_LIST_EMPTY: 'GET_ONE_DRIVER_LICENSE_DOC_LIST_EMPTY',


	DOWNLOAD_ONE_DRIVER_LICENSE_DOC_PDF_REQUEST: 'DOWNLOAD_ONE_DRIVER_LICENSE_DOC_PDF_REQUEST',
	DOWNLOAD_ONE_DRIVER_LICENSE_DOC_PDF_SUCCESS: 'DOWNLOAD_ONE_DRIVER_LICENSE_DOC_PDF_SUCCESS',
	DOWNLOAD_ONE_DRIVER_LICENSE_DOC_PDF_FAILURE: 'DOWNLOAD_ONE_DRIVER_LICENSE_DOC_PDF_FAILURE',

}